import React from 'react';
import ReactDom from 'react-dom';

import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';

import {Tex} from 'react-tex';

class AaStudyTable extends React.Component{


render(){

  //Here are the tex constants that will be put in SI units


  return(

<MuiThemeProvider>

  <div style = {{paddingBottom: 40}}>

  <Table>
        <TableHeader>
          <TableRow>
            <TableHeaderColumn> Name</TableHeaderColumn>
            <TableHeaderColumn>3 letter code</TableHeaderColumn>
            <TableHeaderColumn>1 letter code</TableHeaderColumn>
            <TableHeaderColumn>Structure</TableHeaderColumn>
          </TableRow>
        </TableHeader>
        <TableBody>
          <TableRow>
            <TableRowColumn style = {{textAlign: 'center'}}> Alanine</TableRowColumn>
            <TableRowColumn style = {{textAlign: 'center'}}> Ala  </TableRowColumn>
            <TableRowColumn style = {{textAlign: 'center'}}> A </TableRowColumn>
            <TableRowColumn style = {{paddingTop: 10, paddingBottom: 10}}> <img src = {require("./AaImages/Ala.gif")} /> </TableRowColumn>
          </TableRow>
          <TableRow>
            <TableRowColumn style = {{textAlign: 'center'}}> Arginine </TableRowColumn>
            <TableRowColumn style = {{textAlign: 'center'}}> Arg </TableRowColumn>
            <TableRowColumn style = {{textAlign: 'center'}}> R </TableRowColumn>
            <TableRowColumn style = {{paddingTop: 10, paddingBottom: 10}}> <span> <img src = {require("./AaImages/Arg.gif")} style = {{width: 150}} /> </span> </TableRowColumn>
          </TableRow>
          <TableRow>
            <TableRowColumn style = {{textAlign: 'center'}}> Asparagine </TableRowColumn>
            <TableRowColumn style = {{textAlign: 'center'}}> Asn </TableRowColumn>
            <TableRowColumn style = {{textAlign: 'center'}}> N </TableRowColumn>
            <TableRowColumn style = {{paddingTop: 10, paddingBottom: 10}}> <img src = {require("./AaImages/Asn.gif")} /> </TableRowColumn>
          </TableRow>
          <TableRow>
            <TableRowColumn style = {{textAlign: 'center'}}> Aspartic Acid </TableRowColumn>
            <TableRowColumn style = {{textAlign: 'center'}}> Asp</TableRowColumn>
            <TableRowColumn style = {{textAlign: 'center'}}> D</TableRowColumn>
            <TableRowColumn style = {{paddingTop: 10, paddingBottom: 10}}> <img src = {require("./AaImages/Asp.gif")} /> </TableRowColumn>
          </TableRow>
          <TableRow>
            <TableRowColumn style = {{textAlign: 'center'}}> Cysteine </TableRowColumn>
            <TableRowColumn style = {{textAlign: 'center'}}> Cys </TableRowColumn>
            <TableRowColumn style = {{textAlign: 'center'}}> C </TableRowColumn>
            <TableRowColumn style = {{paddingTop: 10, paddingBottom: 10}}> <img src = {require("./AaImages/Cys.gif")} /> </TableRowColumn>
          </TableRow>
          <TableRow>
            <TableRowColumn style = {{textAlign: 'center'}}> Glutamine </TableRowColumn>
            <TableRowColumn style = {{textAlign: 'center'}}> Gln </TableRowColumn>
            <TableRowColumn style = {{textAlign: 'center'}}> Q </TableRowColumn>
            <TableRowColumn style = {{paddingTop: 10, paddingBottom: 10}}> <img src = {require("./AaImages/Gln.gif")} /> </TableRowColumn>
          </TableRow>
          <TableRow>
            <TableRowColumn style = {{textAlign: 'center'}}> Glutamic Acid</TableRowColumn>
            <TableRowColumn style = {{textAlign: 'center'}}> Glu </TableRowColumn>
            <TableRowColumn style = {{textAlign: 'center'}}> E </TableRowColumn>
            <TableRowColumn style = {{paddingTop: 10, paddingBottom: 10}}> <img src = {require("./AaImages/Glu.gif")} /> </TableRowColumn>
          </TableRow>
          <TableRow>
            <TableRowColumn style = {{textAlign: 'center'}}> Glycine</TableRowColumn>
            <TableRowColumn style = {{textAlign: 'center'}}> Gly</TableRowColumn>
            <TableRowColumn style = {{textAlign: 'center'}}> G </TableRowColumn>
            <TableRowColumn style = {{paddingTop: 10, paddingBottom: 10}}> <img src = {require("./AaImages/Gly.gif")} /> </TableRowColumn>
          </TableRow>
          <TableRow>
            <TableRowColumn style = {{textAlign: 'center'}}> Histidine</TableRowColumn>
            <TableRowColumn style = {{textAlign: 'center'}}> His </TableRowColumn>
            <TableRowColumn style = {{textAlign: 'center'}}> H </TableRowColumn>
            <TableRowColumn style = {{paddingTop: 10, paddingBottom: 10}}> <img src = {require("./AaImages/His.gif")} /> </TableRowColumn>
          </TableRow>
          <TableRow>
            <TableRowColumn style = {{textAlign: 'center'}}> Isoleucine</TableRowColumn>
            <TableRowColumn style = {{textAlign: 'center'}}> Ile </TableRowColumn>
            <TableRowColumn style = {{textAlign: 'center'}}> I </TableRowColumn>
            <TableRowColumn style = {{paddingTop: 10, paddingBottom: 10}}> <img src = {require("./AaImages/Ile.gif")} /> </TableRowColumn>
          </TableRow>
          <TableRow>
            <TableRowColumn style = {{textAlign: 'center'}}> Leucine </TableRowColumn>
            <TableRowColumn style = {{textAlign: 'center'}}> Leu </TableRowColumn>
            <TableRowColumn style = {{textAlign: 'center'}}> L </TableRowColumn>
            <TableRowColumn style = {{paddingTop: 10, paddingBottom: 10}}> <img src = {require("./AaImages/Leu.gif")} /> </TableRowColumn>
          </TableRow>
          <TableRow>
            <TableRowColumn style = {{textAlign: 'center'}}> Lysine </TableRowColumn>
            <TableRowColumn style = {{textAlign: 'center'}}> Lys</TableRowColumn>
            <TableRowColumn style = {{textAlign: 'center'}}> K </TableRowColumn>
            <TableRowColumn style = {{paddingTop: 10, paddingBottom: 10}}> <img src = {require("./AaImages/Lys.gif")} /> </TableRowColumn>
          </TableRow>
          <TableRow>
            <TableRowColumn style = {{textAlign: 'center'}}> Methionine </TableRowColumn>
            <TableRowColumn style = {{textAlign: 'center'}}> Met </TableRowColumn>
            <TableRowColumn style = {{textAlign: 'center'}}> M </TableRowColumn>
            <TableRowColumn style = {{paddingTop: 10, paddingBottom: 10}}> <img src = {require("./AaImages/Met.gif")} /> </TableRowColumn>
          </TableRow>
          <TableRow>
            <TableRowColumn style = {{textAlign: 'center'}}> Phenylalanine </TableRowColumn>
            <TableRowColumn style = {{textAlign: 'center'}}> Phe </TableRowColumn>
            <TableRowColumn style = {{textAlign: 'center'}}> F </TableRowColumn>
            <TableRowColumn style = {{paddingTop: 10, paddingBottom: 10}}> <img src = {require("./AaImages/Phe.gif")} /> </TableRowColumn>
          </TableRow>
          <TableRow>
            <TableRowColumn style = {{textAlign: 'center'}}> Proline </TableRowColumn>
            <TableRowColumn style = {{textAlign: 'center'}}> Pro </TableRowColumn>
            <TableRowColumn style = {{textAlign: 'center'}}> P </TableRowColumn>
            <TableRowColumn style = {{paddingTop: 10, paddingBottom: 10}}> <img src = {require("./AaImages/Pro.gif")} /> </TableRowColumn>
          </TableRow>
          <TableRow>
            <TableRowColumn style = {{textAlign: 'center'}}> Serine </TableRowColumn>
            <TableRowColumn style = {{textAlign: 'center'}}> Ser </TableRowColumn>
            <TableRowColumn style = {{textAlign: 'center'}}> S </TableRowColumn>
            <TableRowColumn style = {{paddingTop: 10, paddingBottom: 10}}> <img src = {require("./AaImages/Ser.gif")} /> </TableRowColumn>
          </TableRow>
          <TableRow>
            <TableRowColumn style = {{textAlign: 'center'}}> Threonine</TableRowColumn>
            <TableRowColumn style = {{textAlign: 'center'}}> Thr</TableRowColumn>
            <TableRowColumn style = {{textAlign: 'center'}}> T</TableRowColumn>
            <TableRowColumn style = {{paddingTop: 10, paddingBottom: 10}}> <img src = {require("./AaImages/Thr.gif")} /> </TableRowColumn>
          </TableRow>
          <TableRow>
            <TableRowColumn style = {{textAlign: 'center'}}> Tryptophan</TableRowColumn>
            <TableRowColumn style = {{textAlign: 'center'}}> Trp </TableRowColumn>
            <TableRowColumn style = {{textAlign: 'center'}}> W </TableRowColumn>
            <TableRowColumn style = {{paddingTop: 10, paddingBottom: 10}}> <img src = {require("./AaImages/Trp.gif")} /> </TableRowColumn>
          </TableRow>
          <TableRow>
            <TableRowColumn style = {{textAlign: 'center'}}> Tyrosine</TableRowColumn>
            <TableRowColumn style = {{textAlign: 'center'}}> Tyr</TableRowColumn>
            <TableRowColumn style = {{textAlign: 'center'}}> Y</TableRowColumn>
            <TableRowColumn style = {{paddingTop: 10, paddingBottom: 10}}> <img src = {require("./AaImages/Tyr.gif")} /> </TableRowColumn>
          </TableRow>
          <TableRow>
            <TableRowColumn style = {{textAlign: 'center'}}> Valine </TableRowColumn>
            <TableRowColumn style = {{textAlign: 'center'}}> Val </TableRowColumn>
            <TableRowColumn style = {{textAlign: 'center'}}> V </TableRowColumn>
            <TableRowColumn style = {{paddingTop: 10, paddingBottom: 10}}> <img src = {require("./AaImages/Val.gif")} /> </TableRowColumn>
          </TableRow>
        </TableBody>

      </Table>

      </div>

      </MuiThemeProvider>

);
}

}

export default AaStudyTable;



// WEBPACK FOOTER //
// ./src/AaStructures/AaStudyTable.js